<template>
    <div class="a" :style="{position:'fixed',top:position.y +'px',left:position.x+'px'}">
        <el-popover
            placement="top-end"
            width="324"
            v-model="showPop"
            popper-class="noPadding noArrow emotion-pop"
            :visible-arrow="false"
            v-if="get(emotions, `0.iconList.length`)"
            ref="popover"
            trigger="manual"
          >
            <div style="height: 250px">
              <l-scroll-bar style="padding: 12px 0 12px 12px">
                <div class="face-box">
                  <div
                    class="face-item"
                    @click="insertEmoji(i)"
                    :title="i.Tip"
                    v-for="i in emotions[0].iconList"
                    :key="i.Code"
                  >
                    <img :src="`${apiUrl}/message/icon/get/${i.Code}`" alt="" />
                  </div>
                </div>
              </l-scroll-bar>
            </div>
          </el-popover>
          112233
    </div>
</template>

<script>
    import { get } from "lodash";
export default {

    name: 'editorEmojiDg',
    props: {
        position: {
            type: Object,
            default: () => {
                return {
                    x: 0,
                    y: 0
                }
            }
        }
    },
    data() {
        return {
            showPop: true
        };
    },
    computed: {

    },
    mounted() {
        console.log(this.emotions[0].iconList,"77777======================")
    },
    // beforeDestroy() {
    //     document.removeEventListener('keyup', this.keyDownHandler)
    // },
    methods: {
        get,
        insertEmoji(item) {
            let src_ = `${this.apiUrl}/message/icon/get/${item.Code}`;
            let str = `<img msgType="emoji" code="${item.Code}" tip="${item.Tip}" style="width: 20px;height: 20px;vertical-align:middle" src="${src_}"/>`;
            // this.insertHtmlAtCaret(str);
            this.$emit('insertEmoji',{src:src_ ,str: str })
        }
    }
}
</script>
<style lang="less" scoped>
  .face-box {
    display: flex;
    flex-wrap: wrap;
    user-select: none;
    .face-item {
      height: 40px;
      width: 40px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12;
      &:hover {
        background-color: rgba(6, 15, 26, 0.05);
      }
      img {
        width: 28px;
        height: 28px;
        pointer-events: none;
      }
    }
  }

</style>